
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/checkout/payment/[plan]",
      function () {
        return require("private-next-pages/checkout/payment/[plan].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/checkout/payment/[plan]"])
      });
    }
  